import { createColumnHelper } from "@tanstack/react-table";
import { dateFormatter } from "../../../utils/dateFormatter";
const columnHelper = createColumnHelper();

export const refundTableColumnsConfig = (
  handleOpenModal,
  handleRefundDetails,
) => [
  columnHelper.accessor("id", {
    header: "ID",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("order_id", {
    header: "Order Id",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("delivered_on", {
    header: "Delivered On",
    cell: (info) => dateFormatter(info.getValue()),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("postal_code", {
    header: "PinCode",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("price", {
    header: "Total Amount",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),


  columnHelper.display({
    id: "view_details",
    header: "View Details",
    cell: (props) => (
      <button
        onClick={() => handleRefundDetails(props.row.original.id)}
        style={{
          padding: "6px 12px",

          background:
            "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",

          color: "#FFFFFF",

          border: "none",
          borderRadius: "6px",

          fontWeight: 500,
          fontSize: "13px",

          cursor: "pointer",

          transition: "all 0.18s ease",

          boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
          e.currentTarget.style.boxShadow =
            "0 4px 12px rgba(47,53,103,0.35)";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background =
            "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
          e.currentTarget.style.boxShadow =
            "0 2px 6px rgba(47,53,103,0.3)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        View Details
      </button>
    ),
  }),
];
